import {FC} from "react";
import {PageBase} from "../../../components/pageBase/pageBase";
import {makeStyles} from "tss-react/mui";
import {AnnouncementPage} from "./AnnouncementPage";
import {Box} from "@mui/material";
import {CourseSideMenuContent} from "../../CoursePage/CourseSideMenuContent";
import {useOrientation} from "@/hooks/useOrientation";
import {landscapePageBaseVideoStyles} from "@/styles/landscapeVideoPlayerStyles";

const useStyles = makeStyles<{ shouldHideUI: boolean }>()((theme, {shouldHideUI}) => ({
	pageBaseLandscape: landscapePageBaseVideoStyles(shouldHideUI),
	pageContent: {
		height: "100%",
		"& [class*='background']":  {
			backgroundColor: "white",
			[theme.breakpoints.down("sm")]: {
				backgroundColor: "#F2F1F4"
			}
		}
	}
}));

export const AnnouncementLandingPage: FC = () => {
	const shouldHideUI = useOrientation();
	const {classes} = useStyles({shouldHideUI});

	return (
		<PageBase className={classes.pageBaseLandscape} sideBarContent={<CourseSideMenuContent />} contentWidth={"3000px"} disableFooter={true}>
			<Box className={classes.pageContent} >
				<AnnouncementPage />
			</Box>
		</PageBase>
	);
}